import React from 'react';
import { Link } from 'react-router';
import { hasAccountMenuData } from './NavData';
import { ShowIfAuthenticated, hideIfAuthenticated } from '../Auth/TokenManager';
import { HTMLTrans } from '../Common/Translations';

export const Login = hideIfAuthenticated(() => (
  <li className="mmm__item mmm__item--top" data-toggle="modal" data-target="#modal-account">
    <a href="#"><HTMLTrans id="navbar.mobilemenutopitems_login">Login / Sign Up</HTMLTrans></a>
  </li>
));


export const MyAccountComp = ShowIfAuthenticated(({ globalShippingCreditMenuItems, data = [], onClick, ...props }) => (
  <li className="mmm__item mmm__item--top">
    <input
      type="checkbox"
      id='myaccount-mobile-menu'
      className="mmm__submenu-toggle"
    />
    <label className="mmm__label" htmlFor='myaccount-mobile-menu'>
      <span className='text-primary'><HTMLTrans id="navbar.mobilemenutopitems_myaccount">MY ACCOUNT</HTMLTrans></span>
      <span className="mmm__arrow mmm__arrow--right"><i className="fa fa-chevron-right"></i></span>
    </label>
    <ul className="mmm__menu mmm__menu--sub">
      <li className="mmm__item mmm__item--title mmm__item--back-nav">
        <label className="mmm__label mmm__label--back-nav" htmlFor='myaccount-mobile-menu'>
          <span className="mmm__arrow mmm__arrow--left"><i className="fa fa-chevron-left"></i></span>
          <span><HTMLTrans id="navbar.mobilemenutopitems_backtomainmenu">Back to main menu</HTMLTrans></span>
        </label>
      </li>

      {globalShippingCreditMenuItems.map(subItem => (
        <li key={subItem.id} className="mmm__item mmm__item--sub">
          <Link
            onClick={onClick}
            className='text-capitalize ProximaNova-Regular'
            to={props.tRoute(subItem.url)}>
            {subItem.label}
          </Link>
        </li>
      ))}

      <li className="mmm__item mmm__item--sub mmm__item-divider" />

      {data.map(subItem => (
        <li key={subItem.id} className="mmm__item mmm__item--sub">
          <Link
            onClick={onClick}
            className='text-capitalize ProximaNova-Regular'
            to={props.tRoute(subItem.url)}>
            {subItem.label}
          </Link>
        </li>
      ))}
    </ul>
  </li>
));

export const MyAccount = hasAccountMenuData(MyAccountComp);



// WEBPACK FOOTER //
// ./src/Nav/MobileMenuTopItems.js